module.exports = __webpack_public_path__ + "img/switchG.c02a3ad8.svg";